import React, { useRef } from "react";
import { injectIntl } from "react-intl";
import styled, { withTheme } from "styled-components";
import { Space } from "antd";
import { useLocalAudioInputActivityPreview } from "amazon-chime-sdk-component-library-react";

const MicrophoneActivityBubble = withTheme(
  injectIntl(({ hidden = false, style = {}, theme }) => {
    const barOne = useRef();
    const barTwo = useRef();
    const barThree = useRef();
    const barColor = theme?.color?.grey?.["grey-1"];

    useLocalAudioInputActivityPreview(barOne, "vertical");
    useLocalAudioInputActivityPreview(barTwo, "vertical");
    useLocalAudioInputActivityPreview(barThree, "vertical");

    return (
      <Space
        className="spaceDots"
        size={3}
        style={{
          background: (hidden ? "transparent" : theme?.color?.blue?.["blue-7"]),
          padding: "0.4em",
          borderRadius: "100%",
          height: "30px",
          width: "30px",
          ...style
        }}
      >
        {!hidden && (
          <>
            <BarOne ref={barOne} barColor={barColor} />
            <BarTwo ref={barTwo} barColor={barColor} />
            <BarThree ref={barThree} barColor={barColor} />
          </>
        )}
      </Space>
    );
  })
);

const BarOne = styled.div`
  position: relative;
  bottom: 0.35em;
  height: 0.7em;
  width: 0.3em;
  background: ${props => props?.barColor ?? "#FFF"};
  border-radius: 4rem;
  transform: scaleY(0);
  transform-origin: center;
  will-change: transform;
`;

const BarTwo = styled.div`
  position: relative;
  bottom: 0.7em;
  height: 1.4em;
  width: 0.3em;
  background: ${props => props?.barColor ?? "#FFF"};
  border-radius: 4rem;
  transform: scaleY(0);
  transform-origin: center;
  will-change: transform;
`;

const BarThree = styled.div`
  position: relative;
  bottom: 0.35em;
  height: 0.7em;
  width: 0.3em;
  background: ${props => props?.barColor ?? "#FFF"};
  border-radius: 4rem;
  transform: scaleY(0);
  transform-origin: center;
  will-change: transform;
`;

export default MicrophoneActivityBubble;
